module.exports = __webpack_public_path__ + "img/changeStonegroup-2.43aebf3.webp";